import React from "react";

interface NumberBadgeProps {
    number: number;
    cssClassName?: string;
}

const CSS_CLASS_NAME = "c-number-badge";

const NumberBadge = (props: NumberBadgeProps) => {
    const { number, cssClassName = "" } = props;
    return (
        <span className={`${CSS_CLASS_NAME} ${cssClassName}`}>{number}</span>
    );
};

export default NumberBadge;
